const createTagFilterValues = (api) => {
  const resultArray = []
  api.forEachNode((rowNode) => {
    if (rowNode.data) {
      const { data: { tags } } = rowNode
      tags.forEach((tag) => {
        !resultArray.some((item) => item.id === tag.id) && resultArray.push(tag)
      })
    }
  })

  return resultArray.sort((a, b) => a.label.localeCompare(b.label))
}

export default createTagFilterValues
